import React from "react";

import MultiSelectFilter from "components/filters/MultiSelectFilter";
import { useAppSelector } from "store";
import { chooseAllStoreSizes, deselectAllStoreSizes, selectStoreSizes, toggleStoreSizeIsSelected } from "modules/customer/tools/location/retailers/retailersSlice";


const StoreSizesDropdown: React.FC = () => {
    const storeSizes = useAppSelector(selectStoreSizes);
    return (
        <MultiSelectFilter
            title="Store sizes"
            items={storeSizes}
            chooseAllItems={chooseAllStoreSizes}
            deselectAllItems={deselectAllStoreSizes}
            toggleItemIsSelected={toggleStoreSizeIsSelected}
        />
    );
};

export default StoreSizesDropdown;
